import React from "react";
import "./Lines.css";


function LinesOne() {
  return (
    <div className="bracket_lines_one">
      <div className="lines_spacer align_right"></div>
      <div className="lines_column lines_one">
        <div className="lines_match">
          <div className="lines_square_spacer" />
          <div className="lines_square_one" />
          <div className="lines_square_spacer" />
        </div>
        <div className="lines_match">
          <div className="lines_square_spacer" />
          <div className="lines_square_one" />
          <div className="lines_square_spacer" />
        </div>
        <div className="lines_match">
          <div className="lines_square_spacer" />
          <div className="lines_square_one" />
          <div className="lines_square_spacer" />
        </div>
        <div className="lines_match">
          <div className="lines_square_spacer" />
          <div className="lines_square_one" />
          <div className="lines_square_spacer" />
        </div>
      </div>
      <div className="lines_column lines_two">
        <div className="lines_match">
          <div className="lines_square_spacer" />
          <div className="lines_square_two" />
          <div className="lines_square_spacer" />
        </div>
      </div>
      <div className="lines_column lines_three" />
      <div className="lines_column lines_four">
        <div className="lines_match">
          <div className="lines_square_spacer" />
          <div className="lines_square_two" />
          <div className="lines_square_spacer" />
        </div>
      </div>
      <div className="lines_column lines_five">
        <div className="lines_match">
          <div className="lines_square_spacer" />
          <div className="lines_square_one" />
          <div className="lines_square_spacer" />
        </div>
        <div className="lines_match">
          <div className="lines_square_spacer" />
          <div className="lines_square_one" />
          <div className="lines_square_spacer" />
        </div>
        <div className="lines_match">
          <div className="lines_square_spacer" />
          <div className="lines_square_one" />
          <div className="lines_square_spacer" />
        </div>
        <div className="lines_match">
          <div className="lines_square_spacer" />
          <div className="lines_square_one" />
          <div className="lines_square_spacer" />
        </div>
      </div>
      <div className="lines_spacer align_left"></div>
    </div>
  );
}

export default LinesOne;
